import { PinInput, Text, Title } from "@mantine/core";
import { useRouter } from "next/navigation";
import SubTopicResourceWrapper from "../../../questions/[topic]/components/SubTopicResourceWrapper";

export default function TestSearchInput({
  error,
  loading,
  onLoad,
}: {
  error: boolean;
  loading: boolean;
  onLoad: (value: string) => void;
}) {
  const router = useRouter();
  return (
    <SubTopicResourceWrapper isPreview>
      <Title
        order={3}
        c={error ? "incorrect" : "lightblue"}
        mb={"md"}
        ta={"center"}
      >
        {error ? "Error Loading Test!" : "Enter test ID"}
      </Title>
      <Text ta={"center"}>
        {error
          ? "We were unable to load the desired test using the link/ID you provided."
          : "To load the custom test, please enter the 8 digit test ID!"}
      </Text>
      {error && (
        <Text ta={"center"}>
          You can try again by entering the test ID below:
        </Text>
      )}
      <PinInput
        mx={"auto"}
        error={error}
        disabled={loading}
        type={new RegExp(`[${testIDPossibleCharacters}]`)}
        length={8}
        onComplete={(value) => {
          router.push(`?testId=${value}`);
          onLoad(value);
        }}
      />
    </SubTopicResourceWrapper>
  );
}

export const testIDPossibleCharacters = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
